import {  Component, QueryList, ViewChildren,} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '../../../services/data/data.service';

import { FiltersM, typesApex } from '../../../components/models';
import { formatear, } from '../../funciones/funcionesGenerales';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';
import { messages } from '../../funciones/mensajes';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
// Registrar fuentes virtuales
pdfMake.addVirtualFileSystem(pdfFonts);
import { GraficasComponent } from '../../../components/graficas/graficas.component';
import { ConstantesImagenes } from '../../../models/Cuestionarios/codigoimagenes';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrl: './perfil.component.css'
})
export class PerfilComponent {
  @ViewChildren(GraficasComponent) grafComp!: QueryList<GraficasComponent>;
  private pdfFile: any;

  public types = typesApex;
  // Variables para los filtros
  sucursales = [];
  consolidado = true;
  filters = {};

  public Filters = FiltersM;
  selectedYears = [];
  selectedMonths: number[] = [0];
  yearsInput: number[] = [0];

  yearsAvailable: any[];
  monthOfYearAvailable: any[];
  monthAvailable: any[];
  yearMonthSelected: string = '';

  /* Greáficas */
  subtitles = '';
  perspectives = ['','','','','',''];
  // Valores para generar la gráfica 1
  tituloZona1 = '';
  data1 = [];
  labels1 = [];
  axisY1 = [];
  graphics1 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona1 = 1;
  // Valores para generar la gráfica 1
  tituloZona2 = '';
  data2 = [];
  labels2 = [];
  axisY2 = [];
  graphics2 = [typesApex.HEATMAP, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona2 = 2;
  // Valores para generar la gráfica 1
  tituloZona3 = '';
  data3 = [];
  labels3 = [];
  axisY3 = [];
  graphics3 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona3 = 3;
  // Valores para generar la gráfica 1
  tituloZona4 = '';
  data4 = [];
  labels4 = [];
  axisY4 = [];
  graphics4 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona4 = 4;
  // Valores para generar la gráfica 1
  tituloZona5 = '';
  data5 = [];
  labels5 = [];
  axisY5 = [];
  graphics5 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona5 = 5;
  // Valores para generar la gráfica 1
  tituloZona6 = '';
  data6 = [];
  labels6 = [];
  axisY6 = [];
  graphics6 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona6 = 6;

  constructor(
    public dataService: DataService,
    public translate: TranslateService,
  ) {
    formatear.momentAbrev();
    this.getPeriodos();
  }
  // Obtención de datos
  private getPeriodos(){
    for(var i = 0; i<10; i++){
      this.sucursales.push({
        name: `Sucursal-${i+1}`,
        check: false
      });
    }

    const start = moment('2023-05-01');
    const end = moment();
    var auxYear = [], auxMounts = [], year = undefined;
    while(start.isSameOrBefore(end)){
      const exYear = auxYear.find(y => y.anio === start.year());
      if(!exYear){
        // year = start.year();
        auxYear.push({
          anio: start.year(),
          name: `${start.year()}`,
          check: false,
        });
      }
      auxMounts.push({
        name: start.format('MMM').toLowerCase(),
        check: false,
        an: start.year(),
        periodo: start.format('MMM-YY').toLowerCase(),
      });
      start.add(1, 'month');
    }
    this.yearsAvailable = auxYear;
    this.yearsAvailable[this.yearsAvailable.length-1].check = true;
    this.monthAvailable = auxMounts;
    const months = this.monthAvailable.filter( y => y.an === auxYear[auxYear.length-1].anio );
    months[months.length-1].check = true;
    this.monthOfYearAvailable = months;

    this.getData();
  }
  private getData(){
    var auxData1Series1 = [];
    // Zona 1
    if(this.perspectives[0] === ''){
      this.data1 = [];
      for(var i = 0; i<2; i++){
        var max = 15, min = 5;
        auxData1Series1.push( Number(( Math.random()* (max - min + 1) + min ).toFixed(1)) );
      }
      this.labels1 = ['Femenino', 'Masculino'];
      this.data1.push({
        name: 'Genero',
        data: auxData1Series1
      })
      this.tituloZona1 = 'Genero';
      this.axisY1 = ['Genero'];
    }
    // Zona 2
    if(this.perspectives[1] === ''){
      this.data2 = [];
      auxData1Series1 = [];
      for(var i = 0; i<9; i++){
        var max = 150, min = 50;
        auxData1Series1.push( Number(( Math.random()* (max - min + 1) + min ).toFixed(1)) );
      }
      this.labels2 = ['-18', '18-25', '26-33', '34-41', '42-49', '50-57', '58-65', '66-80', '+80'];
      this.data2.push({
        name: 'Edad',
        data: auxData1Series1
      })
      this.tituloZona2 = 'Edad';
      this.axisY2 = ['Edad'];
    }
    // Zona 3
    if(this.perspectives[2] === ''){
      this.data3 = [];
      auxData1Series1 = [];
      for(var i = 0; i<6; i++){
        var max = 15, min = 5;
        auxData1Series1.push( Number(( Math.random()* (max - min + 1) + min ).toFixed(1)) );
      }
      this.labels3 = ['Silenciosa', 'Baby boomer', 'gen x', 'millenial', 'centenial', 'gen t'];
      this.data3.push({
        name: 'Generación',
        data: auxData1Series1
      })
      this.tituloZona3 = 'Generación';
      this.axisY3 = ['Generación'];
    }
    // Zona 4
    if(this.perspectives[3] === ''){
      this.data4 = [];
      auxData1Series1 = [];
      for(var i = 0; i<7; i++){
        var max = 15000, min = 5000;
        auxData1Series1.push( Number(( Math.random()* (max - min + 1) + min ).toFixed(0)) );
      }
      this.labels4 = ['primaria', 'secundaria', 'bachillerato', 'licenciatura', 'maestria', 'doctorado', 'NA'];
      this.data4.push({
        name: 'Nivel educación',
        data: auxData1Series1
      })
      this.tituloZona4 = 'Nivel educación';
      this.axisY4 = ['Nivel educación'];
    }
    // Zona 5
    if(this.perspectives[4] === ''){
      this.data5 = [];
      this.labels5 = [];
      auxData1Series1 = [];
      for(var i = 0; i<16; i++){
        var max = 15, min = 5;
        auxData1Series1.push( Number(( Math.random()* (max - min + 1) + min ).toFixed(1)) );
        this.labels5.push(`ocupación ${i+1}`);
      }
      this.data5.push({
        name: 'Ocupación',
        data: auxData1Series1
      })
      this.tituloZona5 = 'Ocupación';
      this.axisY5 = ['Ocupación'];
    }
    // Zona 6
    if(this.perspectives[5] === ''){
      this.data6 = [];
      auxData1Series1 = [];
      for(var i = 0; i<6; i++){
        var max = 15, min = 5;
        auxData1Series1.push( Number(( Math.random()* (max - min + 1) + min ).toFixed(1)) );
      }
      this.labels6 = ['casado', 'soltero', 'unión libre', 'viudo', 'otro', 'NA'];
      this.data6.push({
        name: 'Estado civil',
        data: auxData1Series1
      })
      this.tituloZona6 = 'Estado civil';
      this.axisY6 = ['Estado civil'];
    }
    this.getSubtitles();
  }
  private async getSubtitles(){
    this.subtitles = '';
    for(const per of this.perspectives){
      if(per !== ''){
        this.subtitles += ` ${per} |`;
      }
    }

    const an = this.yearsAvailable.find(y => y.check = true).name.substring(2,4);
    const mes = this.monthOfYearAvailable.find(m => m.check === true).name
    
    this.subtitles += ` ${an} | ${mes}`;

    if(this.consolidado){
      const traduccion = await firstValueFrom(
        this.translate.get('filtros.consolidado')
      );
      this.subtitles += ` | ${traduccion}`;
    }else{
      for(const suc of this.sucursales){
        if(suc.check){
          this.subtitles += ` | ${suc.name}`;
        }
      }
    }
  }
  // Eventos click
  clickGrafic(event: any, zona: number) {
    if(zona-1 === 0 || this.perspectives[zona-2] !== ''){
      this.perspectives[zona-1] = event.name;
      this.getData();
    }
  }
  yearChange(year){
    for(const y of this.yearsAvailable){
      if(y.anio === year.anio){
        y.check = true;
        const months = this.monthAvailable.filter( ye => ye.an === year.anio );
        months[months.length-1].check = true;
        this.monthOfYearAvailable = months;
      }else{
        y.check = false;
      }
    }
    this.getData();
  }
  monthChange(mes){
    for(const m of this.monthOfYearAvailable){
      if(m.name === mes.name){
        m.check = true;
      }else{
        m.check = false;
      }
    }
    this.getData();
  }
  agencyChange(sucClick: any){
    for(const suc of this.sucursales){
      if(sucClick !== 'consolidado' && suc.name === sucClick.name){
        suc.check = true;
      }else{
        suc.check = false;
      }
    }
    if(sucClick === 'consolidado'){
      this.consolidado = !this.consolidado;
    }else{
      this.consolidado = false;
    }
    this.getData();
  }

  resetFilters(){
    this.perspectives = ['','','','','',''];
    this.yearsAvailable[this.yearsAvailable.length-1].check = true;
    const months = this.monthAvailable.filter( y => y.an === this.yearsAvailable[this.yearsAvailable.length-1].anio );
    months[months.length-1].check = true;
    this.monthOfYearAvailable = months;
    this.getData();
  }

  //Exportación de PDF All
  async exportarPDF(){
    try{
      messages.messageSaving(this.translate.instant('acciones.descarga'),this.translate.instant('acciones.espera'))

      const fechaPiePag = new Date().toLocaleDateString('es-MX', {month: '2-digit',day: '2-digit',year: '2-digit',});
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;

      const docPDF = {
        pageSize: 'FOLIO',
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return{
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          }else{
            return{
              text: {
                  text: (currentPage - 1).toString(),
                  alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },margin: [10, -1, 30, 0],
            }
          }
        },
        content: [
          await this.generateZonaPDF(this.zona1),
          await this.generateZonaPDF(this.zona2),
          await this.generateZonaPDF(this.zona3),
          await this.generateZonaPDF(this.zona4),
          await this.generateZonaPDF(this.zona5),
          await this.generateZonaPDF(this.zona6),
        ]
      }

      var reportName = 'Reporte general';
      const pdf = pdfMake.createPdf(docPDF);
      
      pdf.download(reportName);
      const blob = await pdf.getBlob();
      this.pdfFile = blob;

      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'))
    }catch(error){
      Swal.close();
      Swal.fire({title: this.translate.instant('cues.reporte.errorReporte'), timer: 10000});
    }
  }
  async generateZonaPDF(zonaE){
    const comp = this.grafComp.find(g => g.zona === zonaE);
    var img = undefined;
    var table = undefined;
    if(comp.type !== typesApex.TABLE){
      img = await comp.exportImgBlob();
    }
    table = await comp.exportTablePDF();

    var cont = [
      comp.exportTitles(),
      // table !== undefined ? {
      //   text: 'Tabla'
      // } : { text: '' },
      table !== undefined ? table : { text: '' },
      // img !== undefined ? {
      //   text: 'Gráfica'
      // } : { text: '' },
      img !== undefined ? img : { text: '' }
    ];
    return cont;
  }
}
